import { searchActions, translate } from '../../services';

const queryChildren = ( item, predicate ) => {
  let result = [];
  if ( predicate( item ) ) {
    result.push( item );
  }
  for ( let child of item.children ) {
    result = result.concat( queryChildren( child, predicate ) );
  }
  // flatten the result set
  return result;
};

export const searchReducer = ( state = { searchString: '', categories: [], products: [] }, action ) => {
  switch ( action.type ) {
    case searchActions.LOAD:
      console.log('state.searchstring',state.searchString,state,action.query);
      if(state.searchString!==action.query){
        return state;
      }else{
        let products = action.data?action.data.where( m => m.properties.none( p => p.name === 'VTFile' ) ).select():[];
        return { categories: state.categories, products, searchString: action.query };
      }
     
    case searchActions.GETCATEGORIES:
      let regEx = new RegExp( action.query, 'i' );
      let categories = queryChildren( action.topNode, i => regEx.test( i.name )|| regEx.test(i.customProperties?.keyword) || regEx.test( i.description ) || regEx.test( translate( i.name ) ) );
      return { products: state.products, categories, searchString: action.query };
    case searchActions.RESET:
      return { categories: [], products: [], searchString: action.query };
    case searchActions.SETSEARCHKEY:
      return { categories: [], products: [], searchString: action.query };
    default:
      return state;
  }
};